import { useState, useEffect } from 'react';
import { axiosInstance } from '@/App';
import { Package, Tag, TrendingUp } from 'lucide-react';

const Dashboard = () => {
  const [stats, setStats] = useState({ total_products: 0, total_categories: 0, recent_products: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axiosInstance.get('/dashboard/stats');
      setStats(response.data);
    } catch (error) {
      console.error('Failed to fetch stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = [
    {
      title: 'Total Products',
      value: stats.total_products,
      icon: Package,
      color: 'from-blue-500 to-cyan-500',
      testId: 'total-products-stat'
    },
    {
      title: 'Categories',
      value: stats.total_categories,
      icon: Tag,
      color: 'from-purple-500 to-pink-500',
      testId: 'total-categories-stat'
    },
    {
      title: 'Recent Products',
      value: stats.recent_products,
      icon: TrendingUp,
      color: 'from-green-500 to-emerald-500',
      testId: 'recent-products-stat'
    },
  ];

  return (
    <div data-testid="dashboard-page">
      <div className="page-header">
        <h1 className="page-title">Dashboard</h1>
        <p className="page-subtitle">Welcome to your product management system</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {statCards.map((stat) => {
          const Icon = stat.icon;
          return (
            <div key={stat.title} className="card" data-testid={stat.testId}>
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-slate-600 text-sm font-medium mb-2">{stat.title}</p>
                  <p className="text-3xl font-bold text-slate-800">
                    {loading ? '...' : stat.value}
                  </p>
                </div>
                <div className={`p-3 rounded-xl bg-gradient-to-br ${stat.color}`}>
                  <Icon className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 card">
        <h2 className="text-xl font-semibold mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <a
            href="/products/new"
            data-testid="quick-action-add-product"
            className="p-4 border-2 border-dashed border-slate-300 rounded-lg hover:border-indigo-500 hover:bg-indigo-50 transition-colors text-center"
          >
            <Package className="w-8 h-8 mx-auto mb-2 text-slate-600" />
            <p className="font-medium text-slate-700">Add New Product</p>
          </a>
          <a
            href="/categories"
            data-testid="quick-action-manage-categories"
            className="p-4 border-2 border-dashed border-slate-300 rounded-lg hover:border-purple-500 hover:bg-purple-50 transition-colors text-center"
          >
            <Tag className="w-8 h-8 mx-auto mb-2 text-slate-600" />
            <p className="font-medium text-slate-700">Manage Categories</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
